var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKucoinLogo = function SvgKucoinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "kucoin-logo_svg__svg5775",
    viewBox: "0 0 536.8 586.9"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".kucoin-logo_svg__st0{fill:#23af91}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kucoin-logo_svg__layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kucoin-logo_svg__g6382",
    transform: "translate(102.755 165.85)scale(.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kucoin-logo_svg__rect6336",
    d: "M-62.5-137.3c32.5 0 58.9 26.4 58.9 58.9v457.7c0 32.5-26.4 58.9-58.9 58.9s-58.9-26.4-58.9-58.9V-78.4c.1-32.5 26.4-58.9 58.9-58.9",
    className: "kucoin-logo_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kucoin-logo_svg__rect6338",
    d: "M317.8-172.9c22.9 23.1 22.7 60.4-.4 83.2L-8 232.3c-23.1 22.9-60.4 22.7-83.2-.4-22.9-23.1-22.7-60.4.4-83.2l325.4-321.9c23.1-23 60.4-22.8 83.2.3",
    className: "kucoin-logo_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kucoin-logo_svg__rect6340",
    d: "M317.8 473.4c22.9-23.1 22.7-60.4-.4-83.2L-8 68.3c-23.1-22.9-60.4-22.7-83.2.4-22.9 23.1-22.7 60.4.4 83.2l325.4 321.9c23.1 23 60.4 22.8 83.2-.4",
    className: "kucoin-logo_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kucoin-logo_svg__rect6361-4",
    d: "M495.3 226.3c22.9 23.1 22.8 60.4-.2 83.3L323.9 480c-23.1 22.9-60.4 22.8-83.3-.2-22.9-23.1-22.8-60.4.2-83.3L412 226.1c23-22.9 60.3-22.8 83.3.2",
    className: "kucoin-logo_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kucoin-logo_svg__rect6378",
    d: "M495.3 75c22.9-23.1 22.8-60.4-.2-83.3L323.9-178.7c-23.1-22.9-60.4-22.8-83.3.2-22.9 23.1-22.8 60.4.2 83.3L412 75.2c23.1 22.9 60.4 22.9 83.3-.2",
    className: "kucoin-logo_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "kucoin-logo_svg__path6380",
    cx: 282.7,
    cy: 150.7,
    r: 59.4,
    className: "kucoin-logo_svg__st0"
  })))));
};
export { SvgKucoinLogo as ReactComponent };